import baseUrl from "../config/baseUrl";

// Document separation: split a multi-document PDF into child documents linked
// to the client's requests. analyze = detect + match (no documents created),
// save = create/update the reviewed child documents and request links.

const post = async (path, token, body) => {
  try {
    const response = await fetch(`${baseUrl}/api/${path}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    return await response.json();
  } catch (error) {
    return { status: "failed", error: error?.message || "Network error" };
  }
};

export const analyzeDocumentSeparation = ({ token, documentId }) =>
  post("analyze-document-separation", token, { document_id: documentId });

// sourceHash = master.source_hash from the analysis (the save only applies to
// that exact file, so the same analysis can never be applied twice).
export const saveDocumentSeparation = ({ token, documentId, sourceHash, segments }) =>
  post("save-document-separation", token, { document_id: documentId, source_hash: sourceHash, segments });
